
// import CfunTwo from '../components/home/ComFunctionTwo'
export default {
  name: 'Nopage',
  data: function () {
    return {
      msg: '当前页不存在'
    }
  },
  component: {
    // CfunTwo
  },
  methods: {
    toHome () {
      this.$router.push('/home')
    }
  }
}
